export default {
    manage_deletedTemperature: "Alerta de Temperatura fue eliminada exitosamente",
    manage_deletedTemperatures: "Alertas de Temperatura fueron eliminadas exitosamente",
    manage_deleteManageTemperature_deleteTemperature: "Eliminar Alerta de Temperatura",
    manage_deleteManageTemperature_deleteTemperatures: "Eliminar Alertas de Temperatura",
    manage_deleteManageTemperature_confirmationMessage:
    "¿Estás seguro que deseas eliminar las siguientes Alertas de Temperatura?",
}